"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const ProgressSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_4242_12789)">
      <g clipPath="url(#clip0_4242_12789)">
        <rect x="4" y="4" width="24" height="24" rx="12" fill="#E4F1FE" />
        <rect x="4.75" y="4.75" width="22.5" height="22.5" rx="11.25" fill="#E4F1FE" />
        <rect x="4.75" y="4.75" width="22.5" height="22.5" rx="11.25" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="16" cy="16" r="4" fill="currentColor" />
      </g>
    </g>
    <defs>
      <filter id="filter0_d_4242_12789" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feMorphology radius="4" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_4242_12789" />
        <feOffset />
        <feColorMatrix type="matrix" values="0 0 0 0 0.262745 0 0 0 0 0.509804 0 0 0 0 0.890196 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4242_12789" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4242_12789" result="shape" />
      </filter>
      <clipPath id="clip0_4242_12789">
        <rect x="4" y="4" width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>

)

const ProgressIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProgressSvg} {...props} />
);

export default ProgressIcon